export const ProductsConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('app.product', {
      url: '^/products/:product',
      template: '<product-materials></product-materials>',
      resolve: {
        materials: function (data, ProductsDataProvider, $stateParams) {
          "ngInject";
          return ProductsDataProvider.loadProductMaterials($stateParams.product)
        }
      }
    });

  $stateProvider.state('app.product.material', {
    url: '^/products/:product/:material',
    template: '<material-mode> </material-mode>',
    resolve: {
      spec: function (materials, ProductsDataProvider, $stateParams) {
        "ngInject";
        let {
          product,
          material
        } = $stateParams;
        return ProductsDataProvider.loadProductMaterialsSpec(product, material);
      },
      pricing: function (materials, ProductsDataProvider, $stateParams) {
        let {
          product,
          material
        } = $stateParams;
        return ProductsDataProvider.loadProductMaterialPricing(product, material)
      }
    }
  });

  $stateProvider.state('app.product.material.spec', {
    url: '^/products/:product/:material/spec',
    template: '<product-material-spec> </product-material-spec>'
  });

  $stateProvider.state('app.product.material.pricing', {
    url: '^/products/:product/:material/pricing',
    template: '<product-material-pricing> </product-material-pricing>'
  });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/config.js
 **/